import { format as formatDateFns, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import { format, formatInTimeZone } from 'date-fns-tz';

export const formatDateTime = (date: string): string =>
  format(new Date(date), "dd/MM/yyyy 'à' HH'h'mm");

export const formatDate = (date: string): string =>
  format(new Date(date), 'dd/MM/yyyy');

export const formatTime = (date: string): string =>
  format(new Date(date), "HH'h'mm");

/*
 * Calendar dates (`yyyy-MM-dd`, no time nor timezone)
 */
export type TimeZone = 'Europe/Paris';

export const formatCalendarDate = (day: string): string =>
  formatDateFns(parseISO(day), 'dd/MM/yyyy');

// « novembre 2026 », from `yyyy-MM`
export const formatCalendarMonth = (month: string): string =>
  formatDateFns(parseISO(`${month}-01`), 'MMMM yyyy', { locale: fr });

export const todayIn = (timeZone: TimeZone): string =>
  formatInTimeZone(new Date(), timeZone, 'yyyy-MM-dd');

export const toCalendarDate = (value: string | Date): string =>
  typeof value === 'string' ? value : value.toISOString().slice(0, 10);
